import InsertAdUnit from './InsertAdUnit';

export default InsertAdUnit;
